import React, { useState, useEffect } from "react";
import "./vp-rebate.css";
import BottomNav from "../../components/BottomNav/BottomNav";
import InnerHeader from "../../components/InnerHeader";
import UserBalanceHero from "../../components/UserBalanceHero/UserBalanceHero";

const pfreeFormatMoney = (value) => Number(value || 0).toFixed(2);

export default function VIPRebateScreen({
  title = "Promo Free List",

  rows = [
    
  ],
  onBack,
}) {
  const pfreeRows = Array.isArray(rows) ? rows : [];

  return (
    <div className="pfree-page">
      <div className="pfree-shell">
       <InnerHeader title="Rebate Report"/>

        <UserBalanceHero />

        <div className="pfree-content">
          <div className="pfree-title-bar">Auto Promotion</div>

          <div className="pfree-table-wrap">
            <table className="pfree-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Code</th>
                  <th>Title</th>
                  <th>Join Date</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>

              <tbody>
                {pfreeRows.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="pfree-empty-row">
                      No record found!
                    </td>
                  </tr>
                ) : (
                  pfreeRows.map((row, index) => (
                    <tr key={row.id || index}>
                      <td>{index + 1}</td>
                      <td>{row.code}</td>
                      <td>{row.promoTitle}</td>
                      <td>{row.joinDate}</td>
                      <td>{row.startDate}</td>
                      <td>{row.endDate}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}